// extracted by mini-css-extract-plugin
module.exports = {"root":"antd-pro-pages-home-teacher-care-brithday-care-components-index-root"};